import React, { useState } from "react"
import Tabs from "./Tabs"
import Gacha from "./Gacha"
import { valid_key, hasContext } from "../../Utils"
import classes from "./SeedLister.module.css"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Salmonrun from "./Salmonrun"
import Murch from "./Murch"
import Title from "./Title"
import Shop from "./Shop"
import Nameplate from "./Nameplate"

const SeedLister = props => {
    const [activeTab, setActiveTab] = useState(0)
    const { t } = useTranslation()

    if (!valid_key() && !hasContext()) {
        return (
            <>
                <h1>Splatoon 3 - {t("misc:Navigation.SeedListing")}</h1>
                <div className={classes.WrapperRound}>
                    <p>
                        <NavLink to="/settings" end>
                            {t("misc:SeedListing.FirstUse")}
                        </NavLink>
                    </p>
                </div>
            </>
        )
    }

    const changeTabHandler = val => {
        setActiveTab(val)
    }

    return (
        <>
            <h1>Splatoon 3 - {t("misc:Navigation.SeedListing")}</h1>
            {!valid_key() && hasContext() ? (
                <div className={classes.WrapperRound}>
                    <p>
                        <NavLink to="/settings" end>
                            {t("misc:SeedListing.FirstUse")}
                        </NavLink>
                    </p>
                </div>
            ) : null}
            <Tabs clicked={changeTabHandler} active={activeTab} />
            {activeTab === 0 ? (
                <>
                    <Gacha key="Lot" localKey="Lot" />
                </>
            ) : activeTab === 1 ? (
                <>
                    <Gacha key="LotFest" localKey="LotFest" />
                </>
            ) : activeTab === 2 ? (
                <>
                    <Murch />
                </>
            ) : activeTab === 3 ? (
                <>
                    <Title />
                </>
            ) : activeTab === 4 ? (
                <>
                    <Nameplate />
                </>
            ) : activeTab === 5 ? (
                <>
                    <Salmonrun />
                </>
            ) : (
                <>
                    <Shop />
                </>
            )}
        </>
    )
}

export default SeedLister

// dS1hcHU1M3oydXFmNGtyNDNvdW5tbQ==
